import { Outlet, Route, Routes } from "react-router"
import { getRoute, getRouteByComponent } from "src/libs/layouts"
import { IAds } from "../../data/interfaces"
import useEvent from "../../hooks/useEvent"
import { AdContent } from "../ads/AdCardScreen"
import ToposLayoutContainer from "../components/ToposLayoutContainer"
import Day from "./Day"
import Month from "./Month"
import Today from "./Today"
import ToposContainer from "./ToposContainer"
import Week from "./Week"
import Year from "./Year"

const ToposForm = (props:any) : JSX.Element => { 
    useEvent("-1")
    return <div className="w-100 h-100">
        <Routes>
            <Route path="/*" element={<ToposLayoutContainer isAbsolute />} >
                <Route path="/*" element={ <ToposContainer /> }> 
                    {/* <Route index element={ <Navigate replace to={ labels[ range ] } /> } />  */}
                    <Route path="year" element={ <Year /> } />
                    <Route path="month" element={ <Month /> } />
                    <Route path="week" element={ <Week /> } />
                    <Route path="day" element={ <Day /> } />
                    <Route path="today" element={ <Today /> } /> 
                    <Route path="modal" element={ <Outlet /> }> 
                        <Route path=":landId" element={ <Outlet /> }> 
                            <Route path="ad" element={ <Outlet /> }> 
                                <Route 
                                    path=":adId" 
                                    element={
                                        <> 
                                            <AdContent 
                                                item={{} as IAds}
                                                data_type="Ad" 
                                                i={0} 
                                                parentRoute={ `/${getRoute( getRouteByComponent("ToposView")! )}` } 
                                            />
                                        </>
                                    } 
                                /> 
                            </Route>
                        </Route>
                    </Route>
                </Route>
            </Route>
        </Routes> 
    </div>
} 

export default ToposForm